import {  useAuthStore } from "../store";
import {  useUser } from ".";
import { UserTokenKey,PIGNUS } from "../Constants";
import {removeAuthorizationHeader,EncryptKeyToken} from '../helpers/CookieToken'
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import { useSwal } from "../hooks/templateHooks/useSwal";

export const useAuth = () => {
  const { Login, Session, Logout } = useUser();
  const { status, user, errorMessage, onChecking ,session , onLogin, onLogout, clearErrorMessage, onSession  } = useAuthStore();
  const { User } = useUser();
  const {t} = useTranslation('global')
  const { SuccessError } = useSwal();

  const startLogin = async ({ UserName, Password, idUser }) => {
    if (!UserName) return;
    onChecking()

    const Result = Password
      ? await Login({ UserName, Password })
      : IdUser
      ? { res: 1, name: UserName, id: IdUser, errMessage: null }
      : { res: 0, errMessage: null };
    if (Result?.errMessage) { //Si Existe algun Error
      onLogout(Result.errMessage)

      SuccessError("error", t(Result.errMessage));
      setTimeout(() => {
        clearErrorMessage();

      }, 10);
      return;
    } else {
      if (User) {
        const cookies = new Cookies();
        cookies.remove(PIGNUS);
        let keyEncript = User.idUser.toString().padStart(6, '0');
        cookies.set(PIGNUS,     await EncryptKeyToken(keyEncript),{path:"/"});
          onLogin({ name: User.name, id: User.idUser })
       
     } else {
      const cookies = new Cookies();
      cookies.remove(PIGNUS);
      let keyEncript = Result.id.toString().padStart(6, '0');
      cookies.set(PIGNUS,  await EncryptKeyToken(keyEncript),{path:"/"});
      onLogin(Result)
     
     }
    }
  };

  const SessionLogin = async (user) => {
    onChecking();
    const Result = await Session(user);
    if (Result?.errMessage) {
        const sessionItem = JSON.parse(localStorage.getItem(UserTokenKey));
        if (sessionItem) {
          removeAuthorizationHeader();
            await Logout(sessionItem);
        }
        localStorage.removeItem(UserTokenKey);
        onSession(false)
       SuccessError("error",Result.errMessage);
       onLogout(Result.errMessage)
        setTimeout(() => {
          clearErrorMessage()
        }, 10);
    }else {
      if (User) {
        const cookies = new Cookies();
        cookies.remove(PIGNUS);
        let keyEncript = User.idUser.toString().padStart(6, '0');
        cookies.set(PIGNUS,     await EncryptKeyToken(keyEncript),{path:"/"});
        onLogin({ name: User.name, id: User.idUser })
      } else {
        const cookies = new Cookies();
        cookies.remove(PIGNUS);
        let keyEncript = Result.id.toString().padStart(6, '0');
        cookies.set(PIGNUS,  await EncryptKeyToken(keyEncript),{path:"/"});
        onLogin(Result);     
      }
    }
  }

  const startLogout = async () => {
    const sessionItem = JSON.parse(localStorage.getItem(UserTokenKey))
    if (sessionItem) {
      removeAuthorizationHeader(sessionItem.token)
      await Logout({
        refreshToken: `${sessionItem.refreshToken}`,
        idUser: sessionItem.idUser,
      })
    }
    localStorage.removeItem(UserTokenKey);
    const cookies = new Cookies();
    cookies.remove(PIGNUS,{path:"/"});
    onSession(false)
    onLogout();
  };

  const startLogoutMessage = async (err = "") => {
    const sessionItem = JSON.parse(localStorage.getItem(UserTokenKey))
    if (sessionItem) {
      removeAuthorizationHeader(sessionItem.token)
      await Logout({
        refreshToken: `${sessionItem.refreshToken}`,
        idUser: sessionItem.idUser,
      })
    }
    localStorage.removeItem(UserTokenKey);
    onSession(false)
    onLogout(err)
    setTimeout(() => {
      clearErrorMessage()
    }, 10);
    setTimeout(() => {
      window.location.reload(true);
    }, 2000);
  };

  const HaveSession = () => {
    const session = JSON.parse(localStorage.getItem(UserTokenKey))
    onSession(session ? true : false)
  }

  return {
    //Properties
    status,
    user,
    errorMessage,
    session,
    //Methods
    startLogin,
    startLogout,
    startLogoutMessage,
    HaveSession,
    SessionLogin
  };
};
